module.exports = __webpack_public_path__ + "assets/white_cart-b57267.svg";